import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    drawer: {
      width: 600,
    },
    form: {
      display: "flex",
      flexDirection: "column",
      height: "100%",
    },
    header: {
      backgroundColor: theme.gray50,
      padding: theme.spacing(7, 8),
      display: "flex",
      justifyContent: "space-between",
      "& > div": {
        display: "flex",
      },
    },
    title: {
      fontWeight: 500,
      overflow: "hidden",
      textOverflow: "ellipsis",
      textWrap: "nowrap",
      marginRight: theme.spacing(6),
    },
    subtitle: {
      fontWeight: 500,
    },
    closeIcon: {
      cursor: "pointer",
      marginLeft: "auto",
    },
    content: {
      padding: theme.spacing(8),
      display: "flex",
      flexDirection: "column",
      flex: 1,
    },
    subtitleWithIcon: {
      alignItems: "center",
      display: "flex",
      gap: "5px",
    },
    detailsBox: {
      borderRadius: "8px",
      padding: theme.spacing(12),
      marginBottom: theme.spacing(12),
      backgroundColor: theme.gray50,
      "& p": {
        fontSize: 14,
      },
    },
    tabsWrapper: {
      display: "flex",
      gap: theme.spacing(6),
      marginBottom: theme.spacing(4),
    },
    tabName: {
      textTransform: "uppercase",
    },
    bold: {
      fontWeight: 600,
    },
    barChart: {
      marginRight: theme.spacing(4),
      width: theme.spacing(50),
    },
    saveButton: {
      marginLeft: theme.spacing(8),
    },
    progressWrapper: {
      alignItems: "center",
      display: "flex",
      gap: theme.spacing(6),
    },
    orangeAlertTriangleIcon: {
      color: theme.orange500,
      height: "15px",
      width: "15px",
    },
    btnError: {
      color: `${theme.red500} !important`,
    },
    hidden: { display: "none" },
    error: {
      color: theme.red500,
      display: "block",
      fontSize: 12,
      marginTop: theme.spacing(5),
    },
    btnContainer: {
      width: "100%",
      borderTop: `1px solid ${theme.gray100}`,
      display: "flex",
      justifyContent: "end",
      marginTop: "auto",
      padding: theme.spacing(6, 8),
      position: "sticky",
      bottom: 0,
      right: 0,
      backgroundColor: theme.white00,
      zIndex: 3,
    },
    highlighted: {
      color: theme.primary500,
      cursor: "pointer",
    },
    linkWrapper: {
      display: "flex",
      justifyContent: "space-between",
    },
    manageProgressInfo: {
      fontSize: 12,
    },
    tooltipText: {
      whiteSpace: "break-spaces",
    },
    breakWord: {
      wordBreak: "break-word",
    },
    goalDescription: {
      margin: theme.spacing(2, 0, 16),
      "& > div": {
        gap: theme.spacing(2),
      },
      "& #boxElement": {
        backgroundColor: theme.white00,
        minHeight: "24px",
        padding: theme.spacing(0, 3),
        margin: theme.spacing(2, 2, 2, 0),
        "& > div > div": {
          fontSize: 14,
        },
      },
    },
    vectorMargin: {
      margin: theme.spacing(-7, 0, 0, 0),
    },
    goalAdvancedSettings: {
      backgroundColor: `${theme.white00} !important`,
    },
  }),
);
